// extracted by mini-css-extract-plugin
export var container = "widgetForm-module--container--f834c";
export var formDetail = "widgetForm-module--formDetail--d4262";
export var honeypot = "widgetForm-module--honeypot--4e7d6";